import type { ReactNode } from "react";
import Breadcrumb, { type Crumb } from "@/components/base/Breadcrumb";

interface PageHeroProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  crumbs: Crumb[];
  meta?: ReactNode;
}

export default function PageHero({ eyebrow, title, desc, crumbs, meta }: PageHeroProps) {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="w-full px-4 py-8 md:px-6 md:py-12">
        <Breadcrumb items={crumbs} />
        <div className="mt-5 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-3xl">
            {eyebrow && (
              <span className="mb-2.5 inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold tracking-wide text-accent-800">
                <i className="ri-bookmark-3-line"></i>
                {eyebrow}
              </span>
            )}
            <h1 className="font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-4xl">
              {title}
            </h1>
            {desc && (
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
                {desc}
              </p>
            )}
          </div>
          {meta && <div className="shrink-0">{meta}</div>}
        </div>
      </div>
    </section>
  );
}